<template>
    <div class="page-title">
        <h1>{{ main }}</h1>
        <h2>{{ sub }}</h2>
    </div>
</template>

<script>
export default {
    name: 'PageTitle',
    props: ['main', 'sub']
}
</script>

<style>
    .page-title {
        margin: 30px 0 20px;
    }
    
    .page-title h1 {
        font-size: 32px;
        font-weight: 600;
        color: #333;
        font-family: Montserrat;
        position: relative;
        z-index: 1;
    }

    .page-title h1::after {
        content: "";
        width: 1.3rem;
        height: 1.3rem;
        background: rgba(0,148,136,.5);
        position: absolute;
        bottom: 2px;
        left: -7px;
        border-radius: 0.2rem;
        z-index: -1;
    }

    .page-title h2 {
        color: #777;
        margin-top: 05x;
        font-size: 0.5rem;
    }
</style>